import { render, staticRenderFns } from "./frontComprarContainer.vue?vue&type=template&id=a5bd2d48&"
import script from "./frontComprarContainer.vue?vue&type=script&lang=js&"
export * from "./frontComprarContainer.vue?vue&type=script&lang=js&"
import style0 from "./frontComprarContainer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports